import { mapState, mapActions } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'

export const SignatureCacheMixin = {
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('RegistrationSignature', [
      'signatureCache',
      'loadingSignature',
      'loadedSignature'
    ]),
    inviteId () {
      console.log('!!!OVERRIDE COMPUTED - inviteId!!!')
    }
  },
  watch: {
    inviteId () {
      this.refreshSignature()
    }
  },
  methods: {
    ...mapActions('RegistrationSignature', [
      'fetchSignature'
    ]),
    refreshSignature () {
      if (!this.loadedSignature && this.inviteId) {
        this.tryFetchSignature()
      }
    },
    tryFetchSignature () {
      const self = this
      if (self.loadingSignature) {
        return
      }
      self.error = ''
      self.fetchSignature(self.inviteId)
        .catch(error => { self.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshSignature()
  }
}
